const LONG_SUFFIX = 'L';

const defined = function (num) {
    return num !== null && num !== undefined && num !== '';
};

const isDefined = function (what) {
    return what !== null && what !== undefined;
};

const useZeroIfUndefined = function (num) {
    return defined(num) ? num : 0;
};

const suffix = function (num) {
    // TODO: refactor to use moment: https://keap.atlassian.net/browse/FS-49290
    let ret = '';

    if (num !== null && num !== undefined) {
        let lastDigit = -1;

        if (num.length > 1) {
            lastDigit = num.charAt(num.length - 1);
        } else if (num.length > 0) {
            lastDigit = num.charAt(0);
        }

        if (num !== 11 && lastDigit === 1 && navigator.language === 'en') {
            ret = 'st';
        } else if (num !== 12 && lastDigit === 2 && navigator.language === 'en') {
            ret = 'nd';
        } else if (num !== 13 && lastDigit === 3 && navigator.language === 'en') {
            ret = 'rd';
        } else if (navigator.language === 'en') {
            ret = 'th';
        }
    }

    return ret;
};

const useDefaultIfNotDefined = function (what, def) {
    return isDefined(what) ? what : def;
};

const is = function (str) {
    return str !== undefined && str !== null && str !== '' && str !== 'null' && str !== 'undefined';
};

const nz = function (str, backup) {
    return is(str) ? `${str}`
        : is(backup) ? `${backup}` : '';
};

const replaceAll = function (str, s1, s2) {
    return nz(str).split(s1).join(s2);
};

const add = function (array, value) {
    if (array && value) {
        array.push(value);
    }
};

/* eslint-disable no-unused-vars */
const allowAnyFilter = function (item) {
    return true;
};

const executeOnAllFiltered = function (array, filter, callback) {
    if (array) {
        for (let i = 0; i < array.length; i++) {
            const item = array[i];

            if (item && filter && callback && filter(item)) {
                callback(item);
            }
        }
    }
};

const executeOnAll = function (array, callback) {
    executeOnAllFiltered(array, allowAnyFilter, callback);
};

const addAll = function (array1, array2) {
    if (array1 && array2) {
        executeOnAll(array2, (item) => {
            add(array1, item);
        });
    }
};

const sizeOfMap = function (map) {
    if (!map) {
        return 0;
    }

    let size = 0; let key;

    for (key in map) {
        /* eslint-disable no-prototype-builtins */ // TODO
        if (map.hasOwnProperty(key)) {
            size++;
        }
    }

    return size;
};

const endsWith = function (str, pattern) {
    if (str === null || str === undefined || pattern === null) return false;
    const d = str.length - pattern.length;

    return d >= 0 && str.toLowerCase().lastIndexOf(pattern.toLowerCase()) === d;
};

const endsWithL = function (val) {
    return endsWith(val, LONG_SUFFIX);
};

const removeLongSuffix = function (val) {
    return endsWithL(val) ? val.substring(0, val.length - 1) : val;
};

const isValidPositiveLongId = function (val) {
    return removeLongSuffix(val) > 0;
};

const isValidLongId = function (val) {
    return isValidPositiveLongId(val);
};

const ensureLongEndsWithL = function (val) {
    return endsWithL(val) ? val : val + LONG_SUFFIX;
};

const insertNewlines = function (str, maxLineLength) {
    let ret = '';

    if (is(str)) {
        ret = str;
        let lastNewline = 0;
        let lastSpace = 0;
        let lineLength = 0;

        for (let i = 0; i < ret.length; i++) {
            const c = ret.charAt(i);

            if (c === ' ') {
                lastSpace = i;
            } else if (c === '\n') {
                lastNewline = i;
            }

            if (lineLength >= maxLineLength) {
                ret = `${ret.substr(0, lastSpace)}\n${ret.substr(lastSpace + 1)}`;
                lastNewline = lastSpace;
            }

            lineLength = i - lastNewline;
        }
    }

    return ret;
};

const toStrI18nWeeks = function (array, weeksInLocale, labels, addNewLineAfter, formatter) {
    let ret = null;

    if (array) {
        ret = '';

        let c = 0;

        for (let i = 0; i < array.length; i++) {
            c++;
            let val = array[i];

            if (formatter) {
                val = formatter(val);
            }

            const isNextToLast = array.length > 1 && i === array.length - 2;
            const isLast = array.length > 0 && i === array.length - 1;

            let newline;

            if (addNewLineAfter && c >= addNewLineAfter) {
                newline = '\n';
                c = 0; // reset counter
            } else {
                newline = '';
            }
            const or = array.length > 2 ? `, ${newline}${labels('delay.timer.or')} `
                : `${newline} ${labels('delay.timer.or')} `;

            ret += `${weeksInLocale[`delay.timer.week.${val.toLowerCase()}`]}${(isNextToLast ? or : (isLast ? '' : `, ${newline}`))}`;
        }
    }

    return nz(ret);
};

const toStrI18nMonths = function (array, monthsInLocale, labels, addNewLineAfter, formatter) {
    let ret = null;

    if (array) {
        ret = '';

        let c = 0;

        for (let i = 0; i < array.length; i++) {
            c++;
            let val = array[i];

            if (formatter) {
                val = formatter(val);
            }

            const isNextToLast = array.length > 1 && i === array.length - 2;
            const isLast = array.length > 0 && i === array.length - 1;

            let newline;

            if (addNewLineAfter && c >= addNewLineAfter) {
                newline = '\n';
                c = 0; // reset counter
            } else {
                newline = '';
            }

            const or = array.length > 2 ? `,  ${newline}${labels('delay.timer.or')} ` : ` ${newline} ${labels('delay.timer.or')} `;

            ret += `${monthsInLocale[`delay.timer.month.${val.toLowerCase()}`]}${(isNextToLast ? or : (isLast ? '' : `,  ${newline}`))}`;
        }
    }

    return nz(ret);
};

const toStr = function (array, addNewLineAfter, formatter, labels) {
    let ret = null;

    if (array) {
        ret = '';

        let c = 0;

        for (let i = 0; i < array.length; i++) {
            c++;
            let val = array[i];

            if (formatter) {
                val = formatter(val);
            }

            const isNextToLast = array.length > 1 && i === array.length - 2;
            const isLast = array.length > 0 && i === array.length - 1;

            let newline;

            if (addNewLineAfter && c >= addNewLineAfter) {
                newline = '\n';
                c = 0; // reset counter
            } else {
                newline = '';
            }

            const or = array.length > 2 ? `, ${newline}${labels('delay.timer.or')} ` : `${newline} ${labels('delay.timer.or')} `;

            ret += val + (isNextToLast ? or : isLast ? '' : `, ${newline}`);
        }
    }

    return nz(ret);
};

const minLength = function (str, min, c) {
    let ret = '';
    const length = is(str) ? str.length : 0;

    for (let i = min; i > length; i--) {
        ret += c;
    }

    return ret + nz(str);
};

// URL utils

const getFullURL = function (dest) {
    // if doesn't have a ':' means it has not been converted to a full URL (e.g. IE)
    if (dest.indexOf(':') === -1) {
        if (dest.indexOf('/') !== 0) {
            let path = window.location.pathname;
            let url = dest;

            path = path.substring(0, path.lastIndexOf('/'));

            while (/^\.\./.test(url)) {
                path = path.substring(0, path.lastIndexOf('/'));
                url = url.substring(3);
            }
            dest = path + ((url.indexOf('/') === 0) ? '' : '/') + url;
        }

        if (window.location.protocol === 'file:') {
            // We're running through the regression test suite and so we need absolute paths to resolve dependencies
            const root = window.location.href.match(/^.*?webapp/)[0].replace(/file:\/\//, '');
            const context = window.location.href.match(/webapp(.*)resources/)[1].replace(/\/$/, '');

            dest = `${window.location.protocol + root + context + dest}?t=${new Date().getTime()}`; // prevent caching
        } else {
            dest = `${window.location.protocol}//${window.location.host}${dest}`;
        }
    }

    return dest;
};

const getUrl = function (controller, action, params) {
    if (controller !== '' && action !== '') {
        let url = `/app/${controller}/${action}`;

        if (params && params.pathId) {
            url += `/${params.pathId}`;
            delete params.pathId;
        }

        if (params) {
            url += '?';

            let counter = 0;

            for (const i in params) {
                if (Object.prototype.hasOwnProperty.call(params, i)) {
                    if (counter !== 0) {
                        url += '&';
                    }

                    url = `${url + i}=${params[i]}`;
                    counter++;
                }
            }
        }

        return url;
    }

    return '';
};

const removeNonAlphaNumeric = function (str) {
    return nz(str).replace(/[^A-Za-z0-9\u00A1-\u1FFF\u200D-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]/g, '');
};

const parseHtmlTagsToString = function (str) {
    return str.replace(/<[^>]+>/g, ' ');
};

const getSetDifference = function (array1, array2) {
    return [...new Set(array1.filter((element) => !array2.includes(element)))];
};

export const utils = {
    useZeroIfUndefined,
    suffix,
    useDefaultIfNotDefined,
    defined,
    is,
    isDefined,
    minLength,
    nz,
    replaceAll,
    addAll,
    add,
    executeOnAll,
    allowAnyFilter,
    executeOnAllFiltered,
    sizeOfMap,
    isValidLongId,
    insertNewlines,
    toStrI18nWeeks,
    toStrI18nMonths,
    toStr,
    getUrl,
    getFullURL,
    ensureLongEndsWithL,
    removeNonAlphaNumeric,
    parseHtmlTagsToString,
    removeLongSuffix,
    getSetDifference,
};
